import { h } from "@stencil/core";
const render = () => (h("iframe", { src: "/showcase/pages/code-editor.html", frameborder: "0" }));
export const codeEditorShowcaseStory = {
    render: render
};
